import React from 'react';
import { Card, Skeleton } from 'antd';
import { SkHeader, SkStatCards } from './_primitives';

/** BulkOperationsPage — 4 status stats (completed/processing/failed/pending), operations table with progress */
const BulkOperationsPageLoader = () => (
  <div className="w-full p-4 md:p-6">
    <SkHeader actions={2} />
    <SkStatCards count={4} />

    {/* Operations table with progress bars — custom render */}
    <Card className="shadow-sm">
      <Skeleton.Input active size="small" style={{ width: 180, marginBottom: 16 }} />
      <div className="overflow-x-auto">
        <div className="flex gap-4 pb-3 border-b border-gray-200 mb-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton.Input
              key={i}
              active
              size="small"
              style={{ width: '100%', minWidth: 60, maxWidth: '100%', flex: 1 }}
            />
          ))}
        </div>
        {Array.from({ length: 6 }).map((_, r) => (
          <div key={r} className="flex gap-4 py-3 border-b border-gray-100 last:border-b-0">
            {Array.from({ length: 4 }).map((_, c) => (
              <Skeleton.Input
                key={c}
                active
                size="small"
                style={{ width: '100%', minWidth: 60, maxWidth: '100%', flex: 1 }}
              />
            ))}
            {/* Progress bar placeholder */}
            <div className="flex-1 min-w-[60px]">
              <Skeleton.Input active size="small" style={{ width: '100%', height: 8 }} />
            </div>
            {/* Status tag */}
            <Skeleton.Button active size="small" style={{ width: 70 }} />
          </div>
        ))}
      </div>
    </Card>
  </div>
);

export default BulkOperationsPageLoader;
